// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"edd44aa3","170":"0d6591c7","756":"42a57a8a","785":"d78de863","863":"9d7c9fa8"}[chunkId] + ".chunk.js";
};